import { useState, useEffect } from "react";
import Sidebar from "../../../components/dashboard/Sidebar";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion"; 
import userIcon from "../../../assets/images/pharaoh.png";  

const User = () => {
  const [userData, setUserData] = useState([
    { id: 1, name: "Reem Magdy", email: "ReemMagdy@example.com" },
    { id: 2, name: "Ali mohamed", email: "Alimohamed@example.com" },
    { id: 3, name: "amr ahmed", email: "amrahmed@example.com" },
  ]);

  useEffect(() => {
    AOS.init({ duration: 800 });  
  }, []);

  const handleDelete = (id) => {
    setUserData((prevUsers) => prevUsers.filter((user) => user.id !== id));
  };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen">
      <Sidebar />
      <main className="w-full p-4 sm:p-6 lg:ml-6">
        <div className="container mx-auto bg-[#e6c78a10] shadow-md border-t-4 border-[#10AAB2] rounded-lg p-4 sm:p-6" data-aos="fade-up">
          <div className="flex items-center justify-center mb-6" data-aos="fade-right">
            <img src={userIcon} alt="User Icon" className="w-10 h-10 sm:w-12 sm:h-12" />
          
          </div>

          {/* Responsive Table Wrapper */}
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr className="bg-[#E6C78A] text-white text-sm sm:text-base">
                  <th className="px-4 py-3">#</th>
                  <th className="px-4 py-3 text-left">Name</th>
                  <th className="px-4 py-3 text-left">Email</th>
                  <th className="px-4 py-3 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {userData.map((user, index) => (
                  <motion.tr
                    key={user.id}
                    whileHover={{ scale: 1.03 }}
                    transition={{ duration: 0.2 }}
                    className="border-b transition-all duration-500 ease-out hover:bg-[#46A29F]/10"
                    data-aos="fade-up"
                  >
                    <td className="px-4 py-3 text-center font-semibold text-sm sm:text-base">{index + 1}</td>
                    <td className="px-4 py-3 text-gray-700 text-sm sm:text-base">{user.name}</td>
                    <td className="px-4 py-3 text-gray-500 text-sm sm:text-base">{user.email}</td>
                    <td className="px-4 py-3 text-center">
                      <button
                        onClick={() => handleDelete(user.id)}
                        className="text-red-500 hover:text-red-700 transition-transform transform duration-500 hover:scale-125 ease-out"
                      >
                        <i className="fas fa-times-circle text-xl sm:text-2xl"></i>
                      </button>
                    </td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default User;
